import '../../scss/animations/animations.scss';
import Animations from '../animations/animations';

if (document.readyState !== 'loading') {
  new Animations();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    new Animations();
  });
}
